export function pagePreviewSrc(
  pageId: string,
  options?: {
    as?: 'jpeg' | 'png';
    resize?: string;
    // DR-2004: request the pre-rotation original object instead of the stored
    // (rotated) page. `undefined`/`'rotated'` keeps default behavior unchanged.
    variant?: 'original' | 'rotated';
  },
) {
  const { as = 'jpeg', resize, variant } = options ?? {};
  // DR-1809: thumbnails route through /thumbnail, which mints a short-lived
  // signed URL and 302-redirects to the dedicated image-resize service
  // (img.<env>), keeping render load off the user-facing brain API.
  const url = new URL(`/api/document-pages/${pageId}/thumbnail`, window.location.origin);

  url.searchParams.set('inline', '1');
  url.searchParams.set('as', as);
  if (resize) url.searchParams.set('resize', resize);
  if (variant === 'original') url.searchParams.set('variant', 'original');

  return url.toString();
}
